[].forEach.call(document.getElementsByClassName('toggle'), (a) => {
	a.addEventListener('click', (e) => {
		e.preventDefault();
		a.classList.toggle('active');
		a.previousElementSibling.classList.toggle('active');
	});
});

[].forEach.call(document.getElementsByClassName('title'), (t) => {
	t.addEventListener('click', (e) => {
		t.classList.toggle('open')
	});
});